module.exports = __webpack_public_path__ + "img/ingredient.19451d61.jpeg";